import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import OneOnOneList from '../../../component/my/myList/OneOnOne/OneOnOneQuestion';
import CommunityList from '../../../component/my/myList/Freeboard/Freeboard';
import { useTranslation } from '../../../hook/useTranslation';

function MyListPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const headerRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  const [activeTab, setActiveTab] = useState<'1:1' | 'community'>('1:1');

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <FullHeightContainer>
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-50 bg-white min-w-[300px]">
        <TopHeaderWithPrev title={t('my.my_posts')} onClickPrev={() => navigate(Url.My)} />
        <div className="w-full flex items-center justify-between border-b border-[#EAEAEA] mt-[-20px] px-[20px]">
          <button
            type="button"
            className={`flex-1 py-[12px] text-center text-[16px] font-[600] relative ${
              activeTab === '1:1' ? 'text-[#1C1C1C]' : 'text-[#969696]'
            }`}
            onClick={() => setActiveTab('1:1')}
          >
            {t('my.qna.private_title')}
            {activeTab === '1:1' && (
              <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#1C1C1C]" />
            )}
          </button>
          <button
            type="button"
            className={`flex-1 py-[12px] text-center text-[16px] font-[600] relative ${
              activeTab === 'community' ? 'text-[#1C1C1C]' : 'text-[#969696]'
            }`}
            onClick={() => setActiveTab('community')}
          >
            {t('my.community')}
            {activeTab === 'community' && (
              <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#1C1C1C]" />
            )}
          </button>
        </div>
      </div>
      <div
        ref={containerRef}
        className="w-full h-full overflow-y-auto"
        style={{
          paddingTop: headerHeight,
        }}
      >
        <div className="pageInner bg-[#FFF] min-h-[calc(100vh-60px)]">
          {activeTab === '1:1' && <OneOnOneList />}
          {activeTab === 'community' && <CommunityList />}
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default MyListPage;
